export const getUniqueId = (length = 7, allowed = "AZ;az;09") => {
  let characters;

  if (allowed === "AZ;09") {
    characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  } else if (allowed === "az;09") {
    characters = "abcdefghijklmnopqrstuvwxyz0123456789";
  } else if (allowed === "09") {
    characters = "0123456789";
  } else if (allowed === "AZ") {
    characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  } else if (allowed === "az") {
    characters = "abcdefghijklmnopqrstuvwxyz";
  } else if (allowed === "AZ;az") {
    characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  } else {
    characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  }

  // Use timestamp to seed the random number generator
  const timestamp = Date.now();
  let result = "";

  // Create a more unique seed by combining timestamp with a random number
  let seed = timestamp + Math.random();

  for (let i = 0; i < length; i++) {
    // Use the seed to generate a more unique random index
    seed = (seed * 9301 + 49297) % 233280;
    const randomIndex = Math.floor((seed / 233280) * characters.length);
    result += characters[randomIndex];
  }

  return result;
};
